module.exports = __webpack_public_path__ + "static/img/4.7f671f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/4.png
// module id = 7RCc
// module chunks = 4